import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { MpPlntList, SearchParam } from 'models/mp/MpPlnt';
import { callApi } from 'utils/ApiUtil';

/**
 * 공장추가(선택) 팝업 공장기본 조회
 * @param searchParam
 */
export const getFactoryList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/mp/getFactoryList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<MpPlntList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MpPlntList[];
};

/**
 * 공장추가(선택) 팝업 저장
 * @param searchParam
 */
export const saveFactoryList = async (itemId, copCd, saveData: MpPlntList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/mp/saveFactoryList`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: {
      itemId: itemId,
      copCd: copCd,
      factoryList: saveData,
    },
  };
  const response: CommonResponse = await callApi(request);
  return response;
};

/**
 * 공장 정보 저장
 */
export const saveFactory = async (itemId, copCd, mpPrdnPlntId, horExplCrgeUserId, chgRsnCtn) => {
  const param = {
    mpItemId: itemId,
    copCd: copCd,
    mpPrdnPlntId: mpPrdnPlntId,
    horExplCrgeUserId: horExplCrgeUserId,
    chgRsnCtn: chgRsnCtn,
  } as MpPlntList;
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/mp/${param.mpItemId}/factory`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: param,
  };

  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 공장 상태 정보 저장
 */
export const saveFactoryStat = async (
  itemId,
  copCd,
  prdnPlntCd,
  mpPrdnPlntId,
  mpItemStatCd,
  mpItemCondition? // 4MCC 확정전 드랍시 MP ITEM STAT HIS 기록용
) => {
  const param = {
    mpItemId: itemId,
    copCd: copCd,
    prdnPlntCd: prdnPlntCd,
    mpPrdnPlntId: mpPrdnPlntId,
    mpItemStatCd: mpItemStatCd,
    mpItemCondition: mpItemCondition,
  } as MpPlntList;
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/mp/${param.mpItemId}/factory-stat`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: param,
  };

  const response: CommonResponse<string> = await callApi(request);
  return response;
};
